var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Checkbox, Col, ErrorModal, Loading, MessageBanner, Row, TextField, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { fetchAuthorityUpdateStatus, triggerAuthorityUpdateRun, updateAuthorityUpdateSchedule, } from "../../api/adminService";
import { RecekDatepicker } from "../inputs/RecekDatepicker";
import { extractErrorMessage, formatDateTime, formatDuration, fromDateInputValue, hasHttpStatus, toDateInputValue, } from "../../utils/adminJobUtils";
import styles from "./SolrAdmin.module.css";
var AUTHORITY_UPDATE_STATUS_QUERY_KEY = ["authorityUpdateStatus"];
export var AuthorityUpdateAdmin = function () {
    var _a, _b, _c, _d;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var queryClient = useQueryClient();
    var _f = useQuery(AUTHORITY_UPDATE_STATUS_QUERY_KEY, function () { return fetchAuthorityUpdateStatus(ky); }, { refetchInterval: 5000 }), status = _f.data, isLoading = _f.isLoading, error = _f.error;
    var _g = useState(""), cronExpression = _g[0], setCronExpression = _g[1];
    var _h = useState(false), enabled = _h[0], setEnabled = _h[1];
    var _j = useState(""), harvestFrom = _j[0], setHarvestFrom = _j[1];
    var _k = useState(false), seeded = _k[0], setSeeded = _k[1];
    var _l = useState(false), errorOpen = _l[0], setErrorOpen = _l[1];
    var _m = useState(null), errorDetail = _m[0], setErrorDetail = _m[1];
    // Seed the form from the server once, then let the user edit freely.
    useEffect(function () {
        if (status && !seeded) {
            setCronExpression(status.schedule.cronExpression);
            setEnabled(status.schedule.enabled);
            setHarvestFrom(toDateInputValue(status.schedule.harvestFrom));
            setSeeded(true);
        }
    }, [status, seeded]);
    var onMutationError = function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setErrorDetail;
                    return [4 /*yield*/, extractErrorMessage(err)];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    setErrorOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var saveMutation = useMutation({
        mutationFn: function () {
            return updateAuthorityUpdateSchedule(ky, {
                cronExpression: cronExpression,
                enabled: enabled,
                harvestFrom: fromDateInputValue(harvestFrom),
            });
        },
        onSuccess: function () {
            return queryClient.invalidateQueries(AUTHORITY_UPDATE_STATUS_QUERY_KEY);
        },
        onError: onMutationError,
    });
    var runMutation = useMutation({
        mutationFn: function () { return triggerAuthorityUpdateRun(ky); },
        onSuccess: function () {
            return queryClient.invalidateQueries(AUTHORITY_UPDATE_STATUS_QUERY_KEY);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 409: nothing was started - a run is already in progress (maybe on another instance) or none can start now
                        if (hasHttpStatus(err, 409)) {
                            queryClient.invalidateQueries(AUTHORITY_UPDATE_STATUS_QUERY_KEY);
                            setErrorDetail(formatMessage({
                                id: "ui-br-agency.admin.authority-update.run.notStarted",
                            }));
                            setErrorOpen(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, onMutationError(err)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    if (isLoading && !status) {
        return React.createElement(Loading, null);
    }
    if (error && !status) {
        return (React.createElement("div", null,
            formatMessage({ id: "ui-br-agency.modal.label.error" }),
            ":",
            " ",
            formatMessage({ id: "ui-br-agency.admin.authority-update.error" })));
    }
    var running = (_a = status === null || status === void 0 ? void 0 : status.running) !== null && _a !== void 0 ? _a : false;
    var lastRun = (_b = status === null || status === void 0 ? void 0 : status.lastRun) !== null && _b !== void 0 ? _b : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.title", tagName: "h1" }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.description" })),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.title" }), open: errorOpen, content: errorDetail !== null && errorDetail !== void 0 ? errorDetail : formatMessage({ id: "ui-br-agency.admin.authority-update.error" }), onClose: function () { return setErrorOpen(false); } }),
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.schedule.title", tagName: "h2" }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(TextField, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.schedule.cron" }), value: cronExpression, onChange: function (e) {
                        return setCronExpression(e.target.value);
                    } })),
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(RecekDatepicker, { labelId: "ui-br-agency.admin.authority-update.schedule.harvestFrom", value: harvestFrom, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD.MM.YYYY", onChange: function (_e, _displayValue, backendValue) {
                        return setHarvestFrom(backendValue);
                    } })),
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Checkbox, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.schedule.enabled" }), checked: enabled, onChange: function (e) {
                        return setEnabled(e.target.checked);
                    } }))),
        React.createElement("p", { className: styles.hint },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.schedule.cron.hint" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.schedule.nextRun" }),
            " ",
            React.createElement("strong", null, formatDateTime((_c = status === null || status === void 0 ? void 0 : status.nextRunAt) !== null && _c !== void 0 ? _c : null))),
        React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { buttonStyle: "primary", onClick: function () { return saveMutation.mutate(); }, disabled: saveMutation.isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.schedule.save" })),
            React.createElement(Button, { onClick: function () { return runMutation.mutate(); }, disabled: running || runMutation.isLoading }, running ? (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.run.running" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.run.button" })))),
        running && (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.run.inProgress" }))),
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.title", tagName: "h2" }),
        lastRun ? (React.createElement("table", { className: styles.statsTable },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.status" })),
                    React.createElement("td", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.status.".concat(lastRun.status) }))),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.trigger" })),
                    React.createElement("td", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.trigger.".concat(lastRun.trigger) }))),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.startedAt" })),
                    React.createElement("td", null, formatDateTime(lastRun.startedAt))),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.duration" })),
                    React.createElement("td", null, formatDuration(lastRun.durationMs))),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.created" })),
                    React.createElement("td", null,
                        lastRun.totalCreated,
                        " (",
                        lastRun.naturalCreated,
                        " +",
                        " ",
                        lastRun.legalCreated,
                        ")")),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.updated" })),
                    React.createElement("td", null,
                        lastRun.totalUpdated,
                        " (",
                        lastRun.naturalUpdated,
                        " +",
                        " ",
                        lastRun.legalUpdated,
                        ")")),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.merged" })),
                    React.createElement("td", null, (_d = lastRun.mergedPersons) !== null && _d !== void 0 ? _d : 0)),
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.totalRecords" })),
                    React.createElement("td", null, lastRun.totalRecords)),
                lastRun.errorMessage && (React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.error" })),
                    React.createElement("td", { className: styles.unreachableBadge }, lastRun.errorMessage)))))) : (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.authority-update.lastRun.never" })))));
};
